// extracted by mini-css-extract-plugin
export var buttonContent = "_2h-0";
export var centered = "_2h-1";
export var centeredFlex = "_2h-2";
export var errorText = "_2h-3";
export var icon = "_2h-4";
export var iconButtonContent = "_2h-5";
export var monospace = "_2h-6";
export var padded = "_2h-7";